import React from "react";

const FireIconMarked = () => {
  return (
    <svg width={11} height={14} viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.04384 4.86202C1.98127 5.52936 1.93737 6.71038 2.33141 7.21308C2.33141 7.21308 2.14591 5.91572 3.80878 4.28797C4.47832 3.6327 4.63308 2.74145 4.39929 2.07301C4.26648 1.69434 4.02391 1.38152 3.81317 1.1631C3.69024 1.03468 3.78463 0.822842 3.96354 0.830526C5.04578 0.87882 6.79975 1.17956 7.54502 3.04988C7.8721 3.87088 7.89625 4.71933 7.74039 5.58205C7.64161 6.13304 7.29037 7.35796 8.09162 7.50834C8.66347 7.6159 8.94007 7.16149 9.0641 6.83441C9.11569 6.69831 9.29459 6.66428 9.39118 6.77294C10.3571 7.87164 10.4394 9.16572 10.2396 10.2798C9.85327 12.4333 7.67234 14.0007 5.50567 14.0007C2.79899 14.0007 0.644393 12.4519 0.0857135 9.64866C-0.139295 8.51703 -0.0251441 6.27793 1.72004 4.69738C1.84956 4.57884 2.0614 4.68421 2.04384 4.86202Z"
        fill="url(#paint0_radial_1062_693)"
      />
      <path
        d="M6.49475 8.88922C5.49703 7.60503 5.94375 6.13973 6.18851 5.5558C6.22144 5.47897 6.13363 5.40653 6.06449 5.45373C5.63532 5.74569 4.75614 6.43279 4.34674 7.39977C3.79245 8.70702 3.83196 9.34692 4.16015 10.1284C4.35771 10.5993 4.12832 10.6992 4.01307 10.7167C3.90111 10.7343 3.79794 10.6597 3.71562 10.5817C3.47963 10.3567 3.3095 10.0637 3.22828 9.74755C3.21072 9.67949 3.12181 9.66084 3.0812 9.71681C2.77387 10.1416 2.61472 10.8232 2.60704 11.305C2.58289 12.7945 3.8133 14.0019 5.30165 14.0019C7.17745 14.0019 8.54397 11.9274 7.46612 10.1932C7.15331 9.68828 6.85915 9.3579 6.49475 8.88922Z"
        fill="url(#paint1_radial_1062_693)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1062_693"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.96794 14.1301) rotate(-179.75) scale(7.74797 12.7067)"
        >
          <stop offset="0.31" stopColor="#FF9800" />
          <stop offset="0.66" stopColor="#FF6D00" />
          <stop offset="0.97" stopColor="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1062_693"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.92386 6.31116) rotate(90.58) scale(8.10689 6.08017)"
        >
          <stop offset="0.21" stopColor="#FFF176" />
          <stop offset="0.33" stopColor="#FFF27D" />
          <stop offset="0.49" stopColor="#FFF48F" />
          <stop offset="0.67" stopColor="#FFF7AD" />
          <stop offset="0.79" stopColor="#FFF9C4" />
          <stop offset="0.82" stopColor="#FFF8BD" stopOpacity="0.8" />
          <stop offset="0.86" stopColor="#FFF6AB" stopOpacity="0.53" />
          <stop offset="0.91" stopColor="#FFF38D" stopOpacity="0.21" />
          <stop offset="0.94" stopColor="#FFF176" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default FireIconMarked;
